var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#E0F2F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 29.5V27.8333C25.3334 26.9493 24.9822 26.1014 24.3571 25.4763C23.732 24.8512 22.8841 24.5 22.0001 24.5H17.0001C16.116 24.5 15.2682 24.8512 14.6431 25.4763C14.0179 26.1014 13.6667 26.9493 13.6667 27.8333V29.5",
    stroke: "#00695C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 21.1667C21.341 21.1667 22.8334 19.6743 22.8334 17.8333C22.8334 15.9924 21.341 14.5 19.5001 14.5C17.6591 14.5 16.1667 15.9924 16.1667 17.8333C16.1667 19.6743 17.6591 21.1667 19.5001 21.1667Z",
    stroke: "#00695C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 29.5001V27.8334C30.3327 27.0948 30.0869 26.3774 29.6344 25.7937C29.1819 25.2099 28.5484 24.793 27.8333 24.6084",
    stroke: "#00695C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 14.6084C26.0503 14.792 26.6858 15.209 27.1396 15.7937C27.5935 16.3783 27.8398 17.0974 27.8398 17.8376C27.8398 18.5777 27.5935 19.2968 27.1396 19.8815C26.6858 20.4661 26.0503 20.8831 25.3333 21.0667",
    stroke: "#00695C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.7e4ec37e039954efc87e650f8d24405f.svg";
export { ForwardRef as ReactComponent };